import Header from "components/Header";
import Context from "context/Global";
import PortalMessages from "components/PortalMessages";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components/macro";
import Badge from "../LoggedIn/Badge";

let Container = styled.div`
    width: 100%;
    max-width: 100%;
    min-height: 100%;

    > .c-header {
        position: fixed;
        top: 0;
        left: 0;
        height: 60px;
        width: 100%;
        background: #fff;
        z-index: 10;
    }
`;

let MenuWrapper = styled.div`
    width: 300px;
    height: 100%;
    padding-top: 60px;
    position: fixed;
    display: flex;
    flex-direction: column;
    background: #fff;
    z-index: 9;

    > .top {
        overflow: auto;
    }

    > .bottom {
        border-top: 1px solid rgba(0, 0, 0, 0.05);
    }

    @media (max-width: 700px) {
        top: calc(100vh - 60px);
        bottom: 0;
        left: 0;
        padding-top: 0;
        min-width: 100%;
        width: 100vw;
        height: 60px;
        flex-direction: row;
    }
`;

let Content = styled.div`
    padding-top: 60px;
    padding-left: 300px;
    width: 100%;
    height: 100vh;
    min-height: 100vh;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    @media (max-width: 700px) {
        padding-left: 0;
    }

    > .title {
        padding: 1rem;
        font-size: 2rem;
    }

    > .text {
        padding: 0 1rem;
    }
`;

let Item = styled.a`
    width: 100%;
    padding: 0.8em 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: row;
    align-items: center;
    text-decoration: inherit;
    color: inherit;
    font-style: inherit;
    font-size: inherit;
    transition: all 0.3s ease;
    background: #fff;
    color: rgba(0, 0, 0, 0.8);
    cursor: pointer;
    position: relative;

    > .badge {
        position: absolute;
        border-radius: 200px;
        height: 16px;
        width: 16px;
        box-sizing: border-box;
        top: 8px;
        right: calc(100% - 46px);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    &:hover {
        text-decoration: none;
        color: rgba(0, 0, 0, 1);
        background: var(--menu-item--hover, #fafafa);
    }

    &.is-selected {
        color: rgba(0, 0, 0, 1);
        background: var(--menu-item--selected, #eee);
    }

    > .icon {
        padding: 0 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 48px;
        height: 32px;
        min-height: 32px;
        color: inherit;
        box-sizing: border-box;
        flex-shrink: 0;
    }

    > .health {
        display: flex;
        justify-content: space-around;
        width: 100%;
        height: 100%;
        align-items: center;

        > .service {
            > .light {
                width: 12px;
                height: 12px;
                border-radius: 8px;

                &.is-green {
                    background: rgba(0, 200, 0, 1);
                    border: 1px solid rgba(150, 255, 150, 1);
                }
                &.is-orange {
                    background: orange;
                    background: rgba(255, 100, 0, 1);
                    border: 1px solid rgba(255, 200, 150, 1);
                }
                &.is-red {
                    background: rgba(200, 0, 0, 1);
                    border: 1px solid rgba(255, 150, 150, 1);
                }
            }
        }
    }

    > .title {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    @media (max-width: 700px) {
        width: 100%;
        height: 100%;
        justify-content: center;
        flex-direction: column;
        padding: 0;

        > .badge {
            top: 6px;
            left: calc(50% + 6px);
        }

        > .title {
            display: flex;
            font-size: 10px;
            margin-top: 0;
            text-align: center;
            padding: 0 8px;
            line-height: 10px;
        }
    }
`;

function LoggedIn(props) {
    const context = useContext(Context);
    const [menuItems, setMenuItems] = useState([]);
    const [bottomItems, setBottomItems] = useState([]);
    const { t, i18n } = useTranslation();

    useEffect(() => {
        let settingsLink = "";
        if (context.user.administrator) {
            settingsLink = "/admin/brands";
        } else if (context.user.brand && context.user.brand.id) {
            settingsLink = `/admin/brands/${context.user.brand.id}`;
        } else {
            // TODO: Redirect to user view?
        }
        let items = [];

        if (
            ["CLIENT_MANAGER", "OWNER", "SUPPORT"].indexOf(context.user.role) >=
                0 ||
            context.user.administrator
        ) {
            items.push({
                title: "Dashboard",
                icon: (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                    >
                        <path
                            fill="currentColor"
                            d="M5 9v8h-2v-8h2zm2-2h-6v12h6v-12zm6-4v14h-2v-14h2zm2-2h-6v18h6v-18zm6 13v3h-2v-3h2zm2-2h-6v7h6v-7zm1 9h-24v2h24v-2z"
                        />
                    </svg>
                ),
                url: "/admin/dashboard",
            });
        }

        if (
            ["OWNER"].indexOf(context.user.role) >= 0 ||
            context.user.administrator
        ) {
            items.push({
                title: "Sales dashboard",
                icon: (
                    <svg
                        width="24"
                        height="24"
                        xmlns="http://www.w3.org/2000/svg"
                        fillRule="evenodd"
                        clipRule="evenodd"
                    >
                        <path
                            fill="currentColor"
                            d="M5 9v8h-2v-8h2zm2-2h-6v12h6v-12zm6-4v14h-2v-14h2zm2-2h-6v18h6v-18zm6 13v3h-2v-3h2zm2-2h-6v7h6v-7zm1 9h-24v2h24v-2z"
                        />
                    </svg>
                ),
                url: "/admin/sales-dashboard",
                onClick: null,
            });
        }

        if (
            ["CLIENT_MANAGER", "OWNER"].indexOf(context.user.role) >= 0 ||
            context.user.administrator
        ) {
            items.push({
                title: "Försäljning",
                icon: (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                    >
                        <path
                            fill="currentColor"
                            d="M5 9v8h-2v-8h2zm2-2h-6v12h6v-12zm6-4v14h-2v-14h2zm2-2h-6v18h6v-18zm6 13v3h-2v-3h2zm2-2h-6v7h6v-7zm1 9h-24v2h24v-2z"
                        />
                    </svg>
                ),
                url: "/admin/sales",
            });
        }

        if (
            ["SUPPORT", "OWNER", "CLIENT_MANAGER"].indexOf(context.user.role) >=
                0 ||
            context.user.administrator
        ) {
            items.push({
                title: t("menu.option.support"),
                icon: (
                    <svg
                        width="24"
                        height="24"
                        xmlns="http://www.w3.org/2000/svg"
                        fillRule="evenodd"
                        clipRule="evenodd"
                    >
                        <path
                            fill="currentColor"
                            d="M3.848 19h-.848c-.796 0-1.559-.316-2.121-.879-.563-.562-.879-1.325-.879-2.121v-3c0-7.175 5.377-13 12-13s12 5.825 12 13v3c0 .796-.316 1.559-.879 2.121-.562.563-1.325.879-2.121.879h-.848c-2.69 4.633-6.904 5-8.152 5-1.248 0-5.462-.367-8.152-5zm16.152-5.876c-.601.236-1.269-.18-1.269-.797 0-.304-.022-.61-.053-.915-1.761-.254-3.618-1.926-3.699-3.723-1.315 2.005-4.525 4.17-7.044 4.17 1.086-.699 1.839-2.773 1.903-3.508-.581 1.092-2.898 3.136-4.551 3.487l-.018.489c0 .619-.669 1.032-1.269.797v3.771c.287.256.632.464 1.041.594.225.072.412.224.521.424 2.206 4.046 5.426 4.087 6.438 4.087.929 0 3.719-.035 5.877-3.169-1.071.433-2.265.604-3.759.653-.37.6-1.18 1.016-2.118 1.016-1.288 0-2.333-.784-2.333-1.75s1.045-1.75 2.333-1.75c.933 0 1.738.411 2.112 1.005 1.9-.026 4.336-.334 5.888-2.645v-2.236zm-11-.624c.686 0 1.243.672 1.243 1.5s-.557 1.5-1.243 1.5-1.243-.672-1.243-1.5.557-1.5 1.243-1.5zm6 0c.686 0 1.243.672 1.243 1.5s-.557 1.5-1.243 1.5-1.243-.672-1.243-1.5.557-1.5 1.243-1.5zm5.478-1.5h1.357c-.856-5.118-4.937-9-9.835-9-4.898 0-8.979 3.882-9.835 9h1.357c.52-4.023 3.411-7.722 8.478-7.722s7.958 3.699 8.478 7.722z"
                        />
                    </svg>
                ),
                url: "/admin/support",
                onClick: null,
            });
        }

        items.push(
            {
                title: "Dagens försändelser",
                icon: (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                    >
                        <path
                            fill="currentColor"
                            d="M13 17h4v1h-4v-1zm0-1h4v-1h-4v1zm9-14v22h-20v-22h3c1.23 0 2.181-1.084 3-2h8c.82.916 1.771 2 3 2h3zm-11 1c0 .552.448 1 1 1 .553 0 1-.448 1-1s-.447-1-1-1c-.552 0-1 .448-1 1zm9 1h-4l-2 2h-3.897l-2.103-2h-4v18h16v-18zm-7 9h4v-1h-4v1zm0-2h4v-1h-4v1zm-6.5.077l.386-.355c.449.218.735.383 1.241.745.952-1.081 1.58-1.627 2.748-2.355l.125.288c-.963.841-1.669 1.777-2.686 3.6-.626-.738-1.044-1.208-1.814-1.923zm.098 5l.386-.355c.449.218.735.383 1.241.745.952-1.081 1.58-1.627 2.748-2.355l.125.289c-.963.841-1.669 1.777-2.686 3.6-.627-.739-1.045-1.209-1.814-1.924z"
                        />
                    </svg>
                ),
                url: "/admin/orders",
            },
            {
                title: "Missade upphämtningar",
                icon: (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0, 0, 400,400"
                    >
                        <g id="svgg">
                            <path
                                id="path0"
                                d="M65.000 36.480 C -0.600 57.713,-22.244 137.916,24.114 187.988 L 33.333 197.946 33.333 252.912 L 33.333 307.879 37.727 312.273 C 42.001 316.546,42.685 316.667,62.727 316.667 L 83.333 316.667 83.350 322.917 C 83.387 337.259,95.014 353.915,110.333 361.570 C 141.581 377.185,183.233 355.125,183.317 322.917 L 183.333 316.667 216.667 316.667 L 250.000 316.667 250.016 322.917 C 250.100 355.125,291.752 377.185,323.000 361.570 C 338.250 353.950,349.946 337.263,349.984 323.073 L 350.000 316.979 366.250 316.406 C 398.544 315.268,400.303 311.522,399.653 245.297 L 399.167 195.735 386.797 175.784 C 346.954 111.522,354.988 116.667,294.474 116.667 L 250.000 116.667 250.000 96.061 C 250.000 76.019,249.880 75.334,245.606 71.061 L 241.212 66.667 202.912 66.667 L 164.612 66.667 154.654 57.447 C 131.342 35.864,93.932 27.115,65.000 36.480 M113.321 72.168 C 126.120 76.886,139.865 90.832,144.869 104.179 C 166.495 161.860,94.970 208.570,51.533 165.133 C 7.554 121.154,54.517 50.492,113.321 72.168 M83.333 108.333 L 83.333 133.333 108.333 133.333 L 133.333 133.333 133.333 125.000 L 133.333 116.667 116.667 116.667 L 100.000 116.667 100.000 100.000 L 100.000 83.333 91.667 83.333 L 83.333 83.333 83.333 108.333 M216.667 175.000 L 216.667 250.000 233.333 250.000 L 250.000 250.000 250.000 200.000 L 250.000 150.000 287.083 150.003 C 335.081 150.006,330.928 147.897,351.094 182.500 L 366.635 209.167 366.651 246.250 L 366.667 283.333 353.157 283.333 C 340.964 283.333,339.137 282.902,334.407 278.908 C 314.803 262.354,285.197 262.354,265.593 278.908 L 260.352 283.333 216.667 283.333 L 172.981 283.333 167.741 278.908 C 148.136 262.354,118.530 262.354,98.926 278.908 C 94.196 282.902,92.370 283.333,80.176 283.333 L 66.667 283.333 66.667 249.492 L 66.667 215.651 86.400 216.355 C 145.015 218.445,185.111 178.348,183.022 119.733 L 182.318 100.000 199.492 100.000 L 216.667 100.000 216.667 175.000 M266.667 191.667 L 266.667 216.667 308.333 216.667 C 331.250 216.667,350.000 216.193,350.000 215.615 C 350.000 213.221,326.017 172.858,322.831 169.890 C 319.713 166.985,316.767 166.667,293.019 166.667 L 266.667 166.667 266.667 191.667 M143.092 300.708 C 159.126 309.000,151.850 335.000,133.495 335.000 C 122.300 335.000,114.939 327.546,115.059 316.333 C 115.214 301.913,129.752 293.810,143.092 300.708 M309.758 300.708 C 325.793 309.000,318.517 335.000,300.161 335.000 C 288.967 335.000,281.605 327.546,281.726 316.333 C 281.881 301.913,296.418 293.810,309.758 300.708 "
                                stroke="none"
                                fill="currentColor"
                                fillRule="evenodd"
                            ></path>
                        </g>
                    </svg>
                ),
                url: "/admin/missed-pickups",
            },
            {
                title: t("menu.option.spedition"),
                icon: (
                    <svg
                        width="24"
                        height="24"
                        xmlns="http://www.w3.org/2000/svg"
                        fillRule="evenodd"
                        clipRule="evenodd"
                    >
                        <path
                            fill="currentColor"
                            d="M5 11v1h8v-7h-10v-1c0-.552.448-1 1-1h10c.552 0 1 .448 1 1v2h4.667c1.117 0 1.6.576 1.936 1.107.594.94 1.536 2.432 2.109 3.378.188.312.288.67.288 1.035v4.48c0 1.089-.743 2-2 2h-1c0 1.656-1.344 3-3 3s-3-1.344-3-3h-4c0 1.656-1.344 3-3 3s-3-1.344-3-3h-1c-.552 0-1-.448-1-1v-6h-2v-2h7v2h-3zm3 5.8c.662 0 1.2.538 1.2 1.2 0 .662-.538 1.2-1.2 1.2-.662 0-1.2-.538-1.2-1.2 0-.662.538-1.2 1.2-1.2zm10 0c.662 0 1.2.538 1.2 1.2 0 .662-.538 1.2-1.2 1.2-.662 0-1.2-.538-1.2-1.2 0-.662.538-1.2 1.2-1.2zm-3-2.8h-10v2h.765c.549-.614 1.347-1 2.235-1 .888 0 1.686.386 2.235 1h5.53c.549-.614 1.347-1 2.235-1 .888 0 1.686.386 2.235 1h1.765v-4.575l-1.711-2.929c-.179-.307-.508-.496-.863-.496h-4.426v6zm1-5v3h5l-1.427-2.496c-.178-.312-.509-.504-.868-.504h-2.705zm-16-3h8v2h-8v-2z"
                        />
                    </svg>
                ),
                url: "/admin/spedition",
                onClick: null,
            },
            {
                title: "Kunder",
                icon: (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                    >
                        <path
                            fill="currentColor"
                            d="M10.119 16.064c2.293-.53 4.427-.994 3.394-2.946-3.147-5.941-.835-9.118 2.488-9.118 3.388 0 5.643 3.299 2.488 9.119-1.065 1.964 1.149 2.427 3.393 2.946 1.985.458 2.118 1.428 2.118 3.107l-.003.828h-1.329c0-2.089.083-2.367-1.226-2.669-1.901-.438-3.695-.852-4.351-2.304-.239-.53-.395-1.402.226-2.543 1.372-2.532 1.719-4.726.949-6.017-.902-1.517-3.617-1.509-4.512-.022-.768 1.273-.426 3.479.936 6.05.607 1.146.447 2.016.206 2.543-.66 1.445-2.472 1.863-4.39 2.305-1.252.29-1.172.588-1.172 2.657h-1.331c0-2.196-.176-3.406 2.116-3.936zm-10.117 3.936h1.329c0-1.918-.186-1.385 1.824-1.973 1.014-.295 1.91-.723 2.316-1.612.212-.463.355-1.22-.162-2.197-.952-1.798-1.219-3.374-.712-4.215.547-.909 2.27-.908 2.819.015.935 1.567-.793 3.982-1.02 4.982h1.396c.44-1 1.206-2.208 1.206-3.9 0-2.01-1.312-3.1-2.998-3.1-2.493 0-4.227 2.383-1.866 6.839.774 1.464-.826 1.812-2.545 2.209-1.49.345-1.589 1.072-1.589 2.334l.002.618z"
                        />
                    </svg>
                ),
                url: "/admin/customers",
            },
        );

        if (
            ["SUPPORT", "OWNER"].indexOf(context.user.role) >= 0 ||
            context.user.administrator
        ) {
            items.push(
                {
                    title: "Inställningar",
                    icon: (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                        >
                            <path
                                fill="currentColor"
                                d="M20.715 24c-.864 0-1.711-.351-2.322-.962l-10.953-10.952c-.275-.274-.655-.432-1.044-.432l-.111.004c-1.681.129-3.373-.481-4.584-1.692-1.097-1.099-1.701-2.561-1.701-4.117 0-1.046.237-2.225.715-3.279l3.809 3.811c.436-.073.968-.393 1.405-.935.283-.35.427-.675.466-.91l-3.826-3.826c1.056-.476 2.219-.71 3.255-.71 1.533 0 3.043.601 4.143 1.702 1.208 1.209 1.823 2.88 1.69 4.584-.031.428.125.851.43 1.156l10.951 10.951c.62.621.962 1.446.962 2.322 0 1.811-1.474 3.285-3.285 3.285zm-14.319-14.343c.915 0 1.81.371 2.456 1.018l10.953 10.951c.239.24.571.377.909.377.71 0 1.288-.577 1.288-1.287 0-.344-.134-.667-.378-.911l-10.949-10.951c-.715-.716-1.083-1.707-1.009-2.718.088-1.127-.317-2.227-1.111-3.022-.493-.492-1.098-.833-1.758-1l1.49 1.491c.218 1.001.125 1.947-.804 3.097-1.002 1.243-2.292 1.932-3.88 1.586l-1.489-1.49c.167.66.508 1.266 1 1.759.796.794 1.893 1.2 3.017 1.11l.265-.01zm1.664 5.877l-4.665 4.627c-.229.229-.504.407-.79.558l-.579.302-1.026 2.145.833.834 2.101-1.07.301-.58c.15-.286.347-.545.574-.774l4.665-4.627-1.414-1.415zm7.15-7.798l4.507-4.499c.168-.17.442-.168.611 0 .168.17.169.442 0 .611l-4.507 4.5.89.89 4.507-4.5c.169-.169.441-.168.61.001.168.168.17.441.001.609l-4.508 4.5 1.039 1.039 4.767-4.759c.582-.583.873-1.346.873-2.11 0-.768-.293-1.537-.881-2.125-.584-.585-1.35-.877-2.113-.877-.766 0-1.529.293-2.113.877l-4.767 4.759 1.084 1.084zm5.49 12.464c-.276 0-.5.224-.5.5s.224.5.5.5.5-.224.5-.5-.223-.5-.5-.5z"
                            />
                        </svg>
                    ),
                    url: settingsLink,
                },
                {
                    title: "Alla fakturor",
                    icon: (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                        >
                            <path
                                fill="currentColor"
                                d="M7 22v-16h14v7.543c0 4.107-6 2.457-6 2.457s1.518 6-2.638 6h-5.362zm16-7.614v-10.386h-18v20h8.189c3.163 0 9.811-7.223 9.811-9.614zm-10 1.614h-4v-1h4v1zm6-4h-10v1h10v-1zm0-3h-10v1h10v-1zm1-7h-17v19h-2v-21h19v2z"
                            />
                        </svg>
                    ),
                    url: "/admin/invoices/list",
                },
                {
                    title: "All mottagarfrakt",
                    icon: (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                        >
                            <path
                                fill="currentColor"
                                d="M7 22v-16h14v7.543c0 4.107-6 2.457-6 2.457s1.518 6-2.638 6h-5.362zm16-7.614v-10.386h-18v20h8.189c3.163 0 9.811-7.223 9.811-9.614zm-10 1.614h-4v-1h4v1zm6-4h-10v1h10v-1zm0-3h-10v1h10v-1zm1-7h-17v19h-2v-21h19v2z"
                            />
                        </svg>
                    ),
                    url: "/admin/receiver-pays",
                },
            );
        }

        if (context.user.administrator || context.user.role === "OWNER") {
            items.push(
                {
                    title: "Fakturering",
                    icon: (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                        >
                            <path
                                fill="currentColor"
                                d="M8.503 5c-.258-1.675.039-3.562 1.228-5h7.259c-.522.736-1.768 2.175-1.391 5h-1.154c-.147-1.336.066-2.853.562-4h-4.726c-.665 1.003-.89 2.785-.656 4h-1.122zm8.124-1v.675c0 .732-.583 1.325-1.304 1.325h-6.646c-.72 0-1.303-.593-1.303-1.325v-.675h-2.374v20h14v-20h-2.373zm.373 18h-10v-14h10v14zm-1-13h-8v4h8v-4zm-6 7h-2v1h2v-1zm3 0h-2v1h2v-1zm3 0h-2v1h2v-1zm-6-2h-2v1h2v-1zm3 0h-2v1h2v-1zm3 0h-2v1h2v-1zm-6 4h-2v1h2v-1zm3 0h-2v1h2v-1zm3 0h-2v1h2v-1zm0 2h-2v1h2v-1zm-6 0h-2v1h2v-1zm3 0h-2v1h2v-1z"
                            />
                        </svg>
                    ),
                    url: "/admin/invoices/create2",
                },
                {
                    title: "Ej fakturerade försändelser",
                    icon: (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                        >
                            <path
                                fill="currentColor"
                                d="M6 12h10v1h-10v-1zm7.816-3h-7.816v1h9.047c-.45-.283-.863-.618-1.231-1zm-7.816-2h6.5c-.134-.32-.237-.656-.319-1h-6.181v1zm13 3.975v2.568c0 4.107-6 2.457-6 2.457s1.518 6-2.638 6h-7.362v-20h9.5c.312-.749.763-1.424 1.316-2h-12.816v24h10.189c3.163 0 9.811-7.223 9.811-9.614v-3.886c-.623.26-1.297.421-2 .475zm-.5-10.975c-2.483 0-4.5 2.015-4.5 4.5s2.017 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.017-4.5-4.5-4.5zm2.122 3.086l-1.414 1.414 1.414 1.414-.708.707-1.414-1.414-1.414 1.414-.707-.707 1.414-1.414-1.414-1.414.707-.708 1.414 1.414 1.414-1.414.708.708z"
                            />
                        </svg>
                    ),
                    url: "/admin/invoices/remaining",
                },
                {
                    title: "Tillägg",
                    icon: (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                        >
                            <path
                                fill="currentColor"
                                stroke="#000"
                                strokeWidth=".5px"
                                d="M13 20.45c0-.932-.575-1.357-1.109-1.357-.332 0-.672.156-.953.438-.284.296-.389.469-.786.469-.47 0-1.152-.534-1.152-1.5s.682-1.5 1.152-1.5c.396 0 .501.173.785.468.281.283.621.438.953.438.534 0 1.109-.425 1.109-1.357v-3.549h3.55c.536 0 .439.139.108.454-.261.245-.657.616-.657 1.394 0 1.039 1.004 2.152 2.5 2.152s2.5-1.113 2.5-2.152c0-.777-.396-1.148-.658-1.394-.333-.317-.425-.454.108-.454h3.55v-13h-24v24h13v-3.55zm0-19.45h10v11h-2.55c-.933 0-1.356.575-1.356 1.109 0 .332.155.672.438.953.294.284.468.388.468.786 0 .47-.534 1.152-1.5 1.152s-1.5-.682-1.5-1.152c0-.397.174-.501.469-.785.282-.281.438-.621.438-.953 0-.534-.424-1.109-1.356-1.109h-3.551v-3.551c0-.535.137-.44.454-.109.245.263.616.659 1.394.659 1.039 0 2.152-1.004 2.152-2.5s-1.113-2.5-2.152-2.5c-.777 0-1.148.396-1.394.659-.317.333-.454.424-.454-.109v-3.55zm-12 0h11v3.55c0 .932.575 1.357 1.109 1.357.463 0 .775-.252 1.075-.565.207-.221.32-.342.664-.342.47 0 1.152.534 1.152 1.5s-.682 1.5-1.152 1.5c-.344 0-.457-.121-.663-.341-.302-.314-.612-.565-1.075-.565-.535-.001-1.11.424-1.11 1.356v3.55h-3.55c-.536 0-.439-.139-.108-.454.262-.245.658-.616.658-1.394 0-1.039-1.004-2.152-2.5-2.152s-2.5 1.113-2.5 2.152c0 .777.396 1.148.658 1.394.333.317.425.454-.108.454h-3.55v-11zm11 22h-11v-10h3.55c.933 0 1.356-.575 1.356-1.109 0-.463-.25-.773-.564-1.075-.221-.207-.342-.32-.342-.664 0-.47.534-1.152 1.5-1.152s1.5.682 1.5 1.152c0 .344-.121.457-.342.663-.314.302-.564.612-.564 1.075 0 .535.424 1.11 1.356 1.11h3.55v3.55c0 .535-.137.44-.454.109-.245-.263-.616-.659-1.394-.659-1.039 0-2.152 1.004-2.152 2.5s1.113 2.5 2.152 2.5c.777 0 1.148-.396 1.394-.659.317-.333.454-.424.454.109v2.55z"
                            />
                        </svg>
                    ),
                    url: "/admin/addons",
                },
                {
                    title: "Statistik",
                    icon: (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                        >
                            <path
                                fill="currentColor"
                                d="M16.488 20l3.414 4h-2.627l-3.42-4h2.633zm1.512-14h-4v1h4v-1zm-7 18h2v-4h-2v4zm-6.918 0h2.628l3.42-4h-2.633l-3.415 4zm13.918-16h-4v1h4v-1zm0 2h-4v1h4v-1zm-8.5 3c1.762 0 3.205-1.306 3.45-3h-3.95v-3.95c-1.694.245-3 1.688-3 3.45 0 1.933 1.567 3.5 3.5 3.5zm.5-6.95v2.95h2.95c-.221-1.529-1.421-2.729-2.95-2.95zm8 5.95h-4v1h4v-1zm5-9h-1v15h-20v-15h-1v-3h22v3zm-3 0h-16v13h16v-13z"
                            />
                        </svg>
                    ),
                    url: "/admin/statistics",
                },
                {
                    title: "Meddelanden",
                    icon: (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                        >
                            <path
                                fill="currentColor"
                                d="M0 3v18h24v-18h-24zm6.623 7.929l-4.623 5.712v-9.458l4.623 3.746zm-4.141-5.929h19.035l-9.517 7.713-9.518-7.713zm5.694 7.188l3.824 3.099 3.83-3.104 5.612 6.817h-18.779l5.513-6.812zm9.208-1.264l4.616-3.741v9.348l-4.616-5.607z"
                            />
                        </svg>
                    ),
                    url: "/admin/messages",
                },
            );
        }

        if (context.user.administrator) {
            items.push({
                title: "System",
                icon: (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                    >
                        <path
                            fill="currentColor"
                            d="M17 10.645v-2.29c-1.17-.417-1.907-.533-2.28-1.431-.373-.9.07-1.512.6-2.625l-1.618-1.619c-1.105.525-1.723.974-2.626.6-.9-.373-1.017-1.116-1.431-2.28h-2.29c-.412 1.158-.53 1.907-1.431 2.28h-.001c-.9.374-1.51-.07-2.625-.6l-1.617 1.619c.527 1.11.973 1.724.6 2.625-.375.901-1.123 1.019-2.281 1.431v2.289c1.155.412 1.907.531 2.28 1.431.376.908-.081 1.534-.6 2.625l1.618 1.619c1.107-.525 1.724-.974 2.625-.6h.001c.9.373 1.018 1.118 1.431 2.28h2.289c.412-1.158.53-1.905 1.437-2.282h.001c.894-.372 1.501.071 2.619.602l1.618-1.619c-.525-1.107-.974-1.723-.601-2.625.374-.899 1.126-1.019 2.282-1.43zm-8.5 1.689c-1.564 0-2.833-1.269-2.833-2.834s1.269-2.834 2.833-2.834 2.833 1.269 2.833 2.834-1.269 2.834-2.833 2.834zm15.5 4.205v-1.077c-.55-.196-.897-.251-1.073-.673-.176-.424.033-.711.282-1.236l-.762-.762c-.52.248-.811.458-1.235.283-.424-.175-.479-.525-.674-1.073h-1.076c-.194.545-.25.897-.674 1.073-.424.176-.711-.033-1.235-.283l-.762.762c.248.523.458.812.282 1.236-.176.424-.528.479-1.073.673v1.077c.544.193.897.25 1.073.673.177.427-.038.722-.282 1.236l.762.762c.521-.248.812-.458 1.235-.283.424.175.479.526.674 1.073h1.076c.194-.545.25-.897.676-1.074h.001c.421-.175.706.034 1.232.284l.762-.762c-.247-.521-.458-.812-.282-1.235s.529-.481 1.073-.674zm-4 .794c-.736 0-1.333-.597-1.333-1.333s.597-1.333 1.333-1.333 1.333.597 1.333 1.333-.597 1.333-1.333 1.333zm-4 3.071v-.808c-.412-.147-.673-.188-.805-.505s.024-.533.212-.927l-.572-.571c-.389.186-.607.344-.926.212s-.359-.394-.506-.805h-.807c-.146.409-.188.673-.506.805-.317.132-.533-.024-.926-.212l-.572.571c.187.393.344.609.212.927-.132.318-.396.359-.805.505v.808c.408.145.673.188.805.505.133.32-.028.542-.212.927l.572.571c.39-.186.608-.344.926-.212.318.132.359.395.506.805h.807c.146-.409.188-.673.507-.805h.001c.315-.131.529.025.924.213l.572-.571c-.186-.391-.344-.609-.212-.927s.397-.361.805-.506zm-3 .596c-.552 0-1-.447-1-1s.448-1 1-1 1 .447 1 1-.448 1-1 1z"
                        />
                    </svg>
                ),
                url: "/admin/system",
            });
        }

        const items2 = [];

        items2.push({
            title: "User view",
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                >
                    <path
                        fill="currentColor"
                        d="M22 3v18h-5v-2h3v-14h-6v3l-5.25-4 5.25-4v3h8zm-12 16h-6v-14h3v-2h-5v18h8v3l5.25-4-5.25-4v3z"
                    />
                </svg>
            ),
            url: "/quoatations/create",
            onClick: () => {
                context.setLayout("user");
            },
        });

        items2.push({
            title: "Logga ut",
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                >
                    <path
                        fill="currentColor"
                        d="M10 9.408l2.963 2.592-2.963 2.592v-1.592h-8v-2h8v-1.592zm-2-4.408v4h-8v6h8v4l8-7-8-7zm6-3c-1.787 0-3.46.474-4.911 1.295l.228.2 1.396 1.221c1.004-.456 2.114-.716 3.287-.716 4.411 0 8 3.589 8 8s-3.589 8-8 8c-1.173 0-2.283-.26-3.288-.715l-1.396 1.221-.228.2c1.452.82 3.125 1.294 4.912 1.294 5.522 0 10-4.477 10-10s-4.478-10-10-10z"
                    />
                </svg>
            ),
            url: "/logout",
        });

        setMenuItems(items);
        setBottomItems(items2);
    }, [context]);

    return (
        <Container>
            <Header className="c-header" />
            <MenuWrapper>
                <div className="top">
                    {menuItems.map((item, index) => {
                        let isSelected = false;
                        if (item.url === "/") {
                            isSelected =
                                item.url === props.history.location.pathname;
                        } else {
                            isSelected =
                                props.history.location.pathname.indexOf(
                                    item.url,
                                ) === 0;
                        }
                        const editingDraft =
                            props.history.location.pathname.match(
                                /^\/create\/\d+$/g,
                            );
                        if (editingDraft) {
                            isSelected = item.url === "/drafts";
                        }
                        if (
                            props.history.location.pathname ===
                            "/orders/imported"
                        ) {
                            if (item.url === "/orders") {
                                isSelected = false;
                            }
                        }
                        return (
                            <Item
                                key={item.key || index}
                                href={item.url}
                                onClick={(ev) => {
                                    if (item.url) {
                                        props.history.push(item.url);
                                    }
                                    if (item.onClick) {
                                        item.onClick();
                                    }
                                    ev.preventDefault();
                                    return false;
                                }}
                                className={isSelected ? " is-selected" : ""}
                            >
                                <div className="badge">
                                    <Badge badge={item.badge} />
                                </div>
                                <div className="icon">{item.icon}</div>
                                {item.title && (
                                    <div className="title">{item.title}</div>
                                )}

                                {item.content && item.content}
                            </Item>
                        );
                    })}
                </div>
                <PortalMessages />
                <div className="bottom">
                    {bottomItems.map((item, index) => {
                        let isSelected = false;
                        if (item.url === "/") {
                            isSelected =
                                item.url === props.history.location.pathname;
                        } else {
                            isSelected =
                                props.history.location.pathname.indexOf(
                                    item.url,
                                ) === 0;
                        }
                        const editingDraft =
                            props.history.location.pathname.match(
                                /^\/create\/\d+$/g,
                            );
                        if (editingDraft) {
                            isSelected = item.url === "/drafts";
                        }
                        if (
                            props.history.location.pathname ===
                            "/orders/imported"
                        ) {
                            if (item.url === "/orders") {
                                isSelected = false;
                            }
                        }
                        return (
                            <Item
                                key={item.key || index}
                                href={item.url}
                                onClick={(ev) => {
                                    if (item.url) {
                                        props.history.push(item.url);
                                    }
                                    if (item.onClick) {
                                        item.onClick();
                                    }
                                    ev.preventDefault();
                                    return false;
                                }}
                                className={isSelected ? " is-selected" : ""}
                            >
                                <div className="badge">
                                    <Badge badge={item.badge} />
                                </div>
                                <div className="icon">{item.icon}</div>
                                {item.title && (
                                    <div className="title">{item.title}</div>
                                )}
                                {item.content && item.content}
                            </Item>
                        );
                    })}
                </div>
            </MenuWrapper>
            <Content>{props.children}</Content>
        </Container>
    );
}

export default LoggedIn;
